export enum Lang {
  EN,
  FR,
  ES,
  RU,
  ZH,
  IT,
  AR,
  HY
}
